"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var providers_1 = require("./providers");
var embedly_1 = require("./embedly");
var oembed_1 = require("./oembed");
var Embed = /** @class */ (function () {
    function Embed(config) {
        this.config = config;
        // Initialize providers with config
        this.providers = providers_1.providers.reduce(function (acc, providerClass) {
            var providerName = providerClass.name;
            var providerConfig = config.providerConfig
                ? config.providerConfig[providerName]
                : {};
            var provider = new providerClass.className(providerConfig);
            return acc.concat([provider]);
        }, []);
    }
    // Get data from oembed api from the given provider
    Embed.prototype.getOembedData = function (url, provider) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, oembed_1.getOembedData(url, provider)];
                    case 1:
                        data = _a.sent();
                        if (!data)
                            return [2 /*return*/];
                        if (provider.parseData)
                            data = provider.parseData(data);
                        return [2 /*return*/, data];
                }
            });
        });
    };
    // Get data from embedly api. The embedly api returns IEmbedData because
    // it already has that data present.
    Embed.prototype.getEmbedlyData = function (url, provider) {
        return __awaiter(this, void 0, void 0, function () {
            var embedlyConfig, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        embedlyConfig = this.config.embedlyConfig;
                        if (!embedlyConfig || !embedlyConfig.key)
                            return [2 /*return*/];
                        return [4 /*yield*/, embedly_1.getEmbedlyData(url, embedlyConfig)];
                    case 1:
                        data = _a.sent();
                        if (!data)
                            return [2 /*return*/, data];
                        if (provider && provider.parseData) {
                            data = provider.parseData(data);
                        }
                        return [2 /*return*/, data];
                }
            });
        });
    };
    Embed.prototype.preloadThumbnail = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        var img = new Image();
                        img.onload = function () {
                            // Check if width is at least 120, this is the default
                            // fallback for youtube.
                            resolve(img.width > 120);
                        };
                        img.onerror = function () {
                            resolve(false);
                        };
                        img.src = url;
                    })];
            });
        });
    };
    // Check if the thumbnail exists. If it doesn't exist we check the
    // originalThumbUrl if we have one. Getting the image will also preload the it.
    Embed.prototype.checkThumbnail = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var thumbnailUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!data.thumbnailUrl)
                            return [2 /*return*/, data];
                        return [4 /*yield*/, this.preloadThumbnail(data.thumbnailUrl)];
                    case 1:
                        if (_a.sent()) {
                            thumbnailUrl = data.thumbnailUrl;
                        }
                        if (!(!thumbnailUrl && data.originalThumbnailUrl)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.preloadThumbnail(data.originalThumbnailUrl)];
                    case 2:
                        // Try preloading original thumbnail
                        if (_a.sent()) {
                            thumbnailUrl = data.originalThumbnailUrl;
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/, __assign({}, data, { thumbnailUrl: thumbnailUrl })];
                }
            });
        });
    };
    Embed.prototype.getData = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var provider, data, embedUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        provider = this.providers.find(function (p) { return p.regex.test(url); });
                        // Provider not found, fallback to Embedly
                        if (!provider)
                            return [2 /*return*/, this.getEmbedlyData(url)];
                        embedUrl = url;
                        if (!provider.parseUrl) return [3 /*break*/, 2];
                        return [4 /*yield*/, provider.parseUrl(url)];
                    case 1:
                        embedUrl = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!provider.getApiData) return [3 /*break*/, 4];
                        return [4 /*yield*/, provider.getApiData(embedUrl)];
                    case 3:
                        data = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!!data) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.getOembedData(embedUrl, provider)];
                    case 5:
                        data = _a.sent();
                        _a.label = 6;
                    case 6:
                        if (!!data) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.getEmbedlyData(embedUrl, provider)];
                    case 7:
                        data = _a.sent();
                        _a.label = 8;
                    case 8:
                        if (!data)
                            throw new Error("No data returned for url: " + url);
                        return [4 /*yield*/, this.checkThumbnail(data)];
                    case 9:
                        data = _a.sent();
                        // Append extra provider data.
                        return [2 /*return*/, __assign({}, data, { type: provider.type, url: url, providerDisplay: provider.providerDisplay, providerName: provider.providerName, providerUrl: provider.providerUrl, providerIcon: provider.providerIcon })];
                }
            });
        });
    };
    return Embed;
}());
exports.Embed = Embed;
